import { render, staticRenderFns } from "./MasterLayout.vue?vue&type=template&id=d8a56f9c&"
import script from "./MasterLayout.vue?vue&type=script&lang=js&"
export * from "./MasterLayout.vue?vue&type=script&lang=js&"
import style0 from "./MasterLayout.vue?vue&type=style&index=0&id=d8a56f9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports